import { Box, Icon, InputAdornment, TextField } from '@mui/material';  
import React, { useEffect, useState } from 'react';

const useStyles =  () => ({
  field: {
    borderRadius: '15px !important',
    overflow: 'hidden !important',
  },
  bar: {
    display: 'flex !important',
    flexDirection: 'column !important',
  },
  barinfo: {
    height: '12px !important',
    paddingTop: '3px !important',
    fontSize: '0.7rem !important',
    opacity: '0.6 !important',
  },
  searchBar: {
    paddingTop: '6px !important',
  },
  iconHolder: {
    marginTop: '0!important',
    opacity: '0.7 !important',
    marginLeft: '-4px !important',
  },
});

const SearchBar = (props) => {
  const classes = useStyles();
  const [focusState, setFocus] = useState(false);
  const setKeyword = (keyword) => {
    //Pass keyword to parent
    props.onSearch(keyword);
  };

  useEffect(() => {
    props.onFocusChange && props.onFocusChange();
  }, [focusState]);

  return (
    <Box sx={classes.bar}>
      <TextField
        variant="filled"
        size="small"
        margin="none"
        value={props.keyword}
        sx={classes.field}
        onChange={(e) => setKeyword(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        slotProps={{
          input: {
            sx: {
              '& .MuiInputBase-input': classes.searchBar,  
            },
            startAdornment: (
              <InputAdornment
                position="start"
                margin="none" 
                sx={{ ...classes.iconHolder }}
              >
                <Icon>search</Icon>
              </InputAdornment>
            ),
          }
        }}
      />
      {focusState == true && (
        <Box sx={classes.barinfo}>
          Search by Name, Org, City, Tags, etc
        </Box>
      )}
      {focusState == false && <Box sx={classes.barinfo}></Box>}
    </Box>
  );
};

export default SearchBar;
